<div class="row px-3">
  <label class="col sub-text text-uppercase d-inline-flex mb-2">Filters</label>
  @if (facetUtils.hasActiveFilters(overviewFilters)) {
    <button class="col-auto ms-auto btn btn-plain text-primary py-0" (click)="clearFilters()">Clear filters</button>
  }
</div>
<div class="row-md g-0 px-2 d-flex flex-column">
  <ng-container *ngTemplateOutlet="specificFacetFiltersTemplate"></ng-container>
  @for (facet of facets; track facet.name) {
    <div class="col-md-12">
      <app-facet-filter [facet]="facet" (selectedValuesChange)="onFacetValuesChange(facet, $event)"
                        [selectedValues]="overviewFilters?.facets[facet.name]"></app-facet-filter>
    </div>
  }
  @if (hasOtherFacetValueSelected || otherFacets?.length > 0) {
    <div class="col-md-12">
      <div class="dropdown">
        <button class="btn btn-bg-secondary text-start d-flex justify-content-between align-items-center w-100 p-2"
                type="button"
                [ngClass]="{'active': hasOtherFacetValueSelected}" data-bs-toggle="dropdown" data-bs-auto-close="outside"
                data-bs-config='{"popperConfig":{"strategy":"fixed"}}'>
          <div class="d-flex flex-column mw-0 flex-grow-1 me-3">
            <span class="d-inline-block text-truncate">Other</span>
            @if (hasOtherFacetValueSelected) {
              <div class="mt-1 text-secondary d-inline-block text-truncate">
                {{ otherValuesSelectedFormatted }}
              </div>
            }
          </div>
          @if (!hasOtherFacetValueSelected) {
            <i class="fa fa-fw fa-plus text-secondary"></i>
          }
        </button>
        <div class="btn-close-wrapper rounded-circle position-absolute end-0 me-2 mt-2 top-0"
             [ngClass]="{'d-none': !hasOtherFacetValueSelected}">
          <button type="button" class="btn-close" (click)="removeOtherFacets()" aria-label="Remove filter"></button>
        </div>
        <div class="dropdown-menu min-w-100" [style.max-height.px]="320">
          <ul class="list-group">
            @for (facet of otherFacets; track facet.name) {
              <li class="list-group-item list-group-item-action border-0 d-flex align-items-stretch p-0">
                <app-facet-filter-boolean-value [facet]="facet" [formattedFacetName]="facetNameFormatter(facet.name)"
                                                [selectedValues]="overviewFilters?.facets[facet.name]"
                                                (valueSelected)="onFacetValuesChange(facet, $event)"
                                                class="w-100 h-100"></app-facet-filter-boolean-value>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  }
</div>
